import { render, staticRenderFns } from "./colTask.vue?vue&type=template&id=98d4b364"
import script from "./colTask.vue?vue&type=script&lang=js"
export * from "./colTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports